module.exports = __webpack_public_path__ + "media/assets/quotes-4ac3f938.svg";